import { datePillColors } from '@components/DatePill';

export {
  holidayTypes,
  HOLIDAY_TYPE_META,
  HOLIDAY_TYPE_OPTIONS,
  getHolidayType,
} from '@/constants/holidays';

// Cycled by row position purely for visual variety - not tied to holiday type.
const DATE_PILL_COLOR_CYCLE = [
  datePillColors.blue,
  datePillColors.success,
  datePillColors.orange,
  datePillColors.purple,
];

export const getDatePillColor = (index) =>
  DATE_PILL_COLOR_CYCLE[index % DATE_PILL_COLOR_CYCLE.length];
